import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { LockIcon, PlayIcon } from './PrivateContentUtils';


function LiveEventsContent(props) {
  const {
    linkToDirectTo,
    coverPhoto,
    subscribed,
    isBanned,
    isLiveEventsSection,
    shouldBlurContent,
  } = props;

  const isLocked = !subscribed || isBanned;

  if (!isLiveEventsSection) {
    return null;
  }

  return (
    <Link className="content-item gallery-item" to={linkToDirectTo}>
      <div>
        <img
          alt="Private Gallery"
          className={classnames({
            'blur': shouldBlurContent,
          })}
          src={coverPhoto}
          style={{ height: '100%' }}
        />
        <PlayIcon />
        <LockIcon
          isLocked={isLocked}
        />
      </div>
    </Link>
  );
}

export default LiveEventsContent;
